export enum BranchAccountUserRoleActions {
  Assign = 'Assign',
  Remove = 'Remove',
}
